module.exports = __webpack_public_path__ + "static/media/quick_guide_login1.d1f371ae.jpg";